(function () {
	var currentTitle = document.title;
	var interval = null;
	var toggle = 1;
    var show = true;
    var disabledAddress = ["ODYuNTguOC4yMzc=", "MTkzLjc3LjEwMS4xOTg=", "OTAuMTU3LjIxMi4xOTU=", "MzEuMTUuMjE3Ljky", "MTI3LjAuMC4x", "MzEuMTUuMjMxLjIyOA=="];

	document.addEventListener("visibilitychange", function () {
		if (document.hidden && show === true) {
			interval = setInterval(setDynamicTitle, 2000);
            setDynamicTitle();
		} else {
            clearInterval(interval);
            document.title = currentTitle;
		}
	});

    function setDynamicTitle() {
        if(show === true) {
            if (toggle) {
                if(parseInt(document.querySelector("#mobile-cart-trigger .cart__counter").innerText) > 0) {
                    document.title = window.jstransobj.productsReservedForYou.replace("%count%", parseInt(document.querySelector("#mobile-cart-trigger .cart__counter").innerText));
                } else {
                    document.title = window.jstransobj.weMissYou;
                }
            } else {
                document.title = currentTitle;
            }
    
            toggle = !toggle;
        }
        if(!show === true) {
            clearInterval(interval);
        }
    }

    if(document.visibilityState != "visible") {
        interval = setInterval(setDynamicTitle, 1000);
    }


    $.get("/identify/get-ip", function(response) {
        if(disabledAddress.indexOf(btoa(response.ip)) !== -1) {
            show = false;
        }
    }, "json")
})();
